import React, { MouseEventHandler } from 'react'
import _ from 'underscore'

import Selector from './selector'

interface Props {
    type: string
    head?: string
    items: string[]
    selected: string[]
    onUpdate?: any
    onSearch?: any
    onSelectionChange?: any
    removable: boolean
    onRemove?: MouseEventHandler
    sortCompareFunction?: any
    minWidth: number
}

interface State {
    recent: string[]
    search: string[]
    selected: string[]
}

class DropdownSelector extends React.Component<Props, State> {
    public static defaultProps = {
        selected: [],
        items: [],
        removable: false,
        minWidth: 250,
    }

    public state: State = {
        recent: [],
        search: [],
        selected: [],
    }

    public constructor(props: Props) {
        super(props)

        this.state = {
            recent: [],
            search: _.difference(this.props.items, this.props.selected).sort(this.props.sortCompareFunction),
            selected: this.props.selected.sort(this.props.sortCompareFunction),
        }
    }

    public componentDidUpdate(prevProps, prevState) {
        if (prevProps.items.length === 0) {
            this.setState({
                recent: [],
                search: _.difference(this.props.items, this.props.selected).sort(this.props.sortCompareFunction),
                selected: this.props.selected.sort(this.props.sortCompareFunction),
            })
        }

        if (!_.isEqual(prevState.selected, this.state.selected)) {
            this.props.onUpdate(this.state.selected)
        } else if (
            this.props.selected.length !== this.state.selected.length &&
            prevProps?.selected?.length === this.state.selected.length
        ) {
            // Clear filters should remove selected items
            this.setState({
                selected: this.props.selected.sort(this.props.sortCompareFunction),
                search: _.difference(this.props.items, this.props.selected).sort(this.props.sortCompareFunction),
            })
        }
    }

    public changeSelection = (area: 'selected' | 'search', item) => {
        if (typeof this.props.onSelectionChange !== 'undefined') {
            return this.props.onSelectionChange(area, item)
        }

        const other = area === 'selected' ? 'search' : 'selected'

        // @ts-ignore
        this.setState({
            [area]: _.without(this.state[area], item).sort(this.props.sortCompareFunction),
            [other]: _.uniq(_.union(this.state[other], [item]).sort(this.props.sortCompareFunction), true),
        })
    }

    public filterSearch = ev => {
        if (typeof this.props.onSearch !== 'undefined') {
            return this.props.onSearch(ev)
        }

        const q = ev.target.value
        const matching = _.filter(this.props.items, item => item.toLowerCase().indexOf(q.toLowerCase()) >= 0)

        this.setState({
            search: _.difference(matching, this.state.selected).sort(this.props.sortCompareFunction),
        })
    }

    public renderList = (items, area) => {
        return (
            <ul>
                {_.map(items, (item, i) => {
                    const id = this.props.type + '-' + area + '-' + i

                    return (
                        <li key={id}>
                            <div className="checkbox checkbox-default">
                                <input
                                    type="checkbox"
                                    name="id[]"
                                    value={item}
                                    id={id}
                                    checked={area === 'selected'}
                                    onChange={this.changeSelection.bind(this, area, item)}
                                />
                                <label htmlFor={id}>{item}</label>
                            </div>
                        </li>
                    )
                })}
            </ul>
        )
    }

    public render() {
        return (
            <Selector
                type={this.props.type}
                head={this.props.head}
                mainClass="dropdown dropdown-search-select"
                hasCaret
                removable={this.props.removable}
                onRemove={this.props.onRemove}
                headText={(selected => {
                    switch (selected.length) {
                        case 0:
                            return 'All ' + this.props.type + 's'
                        case 1:
                            // @ts-ignore TypeScript cannot infer here that selected has at least one element
                            return _.first(selected).substring(0, 15) + '…'
                        default:
                            return selected.length + ' ' + this.props.type + 's'
                    }
                })(this.state.selected)}
            >
                <div className="dropdown-menu" role="menu" aria-labelledby="dLabel" style={{ minWidth: `${this.props.minWidth}px` }}>
                    <div className="errors-filter-search">
                        <form className="form">
                            <div className="form-group has-feedback">
                                <input className="form-control" type="text" onChange={e => this.filterSearch(e)} />
                                <i className="form-control-feedback fa fa-search" />
                            </div>
                        </form>
                    </div>

                    <div className="divider" />

                    <div
                        style={{
                            minHeight: '100px',
                            maxHeight: '400px',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            padding: '8px',
                            paddingTop: '0px',
                        }}
                    >
                        {this.state.selected && this.state.selected.length > 0 ? (
                            <div className="dropdown-search-select-selected-panel">
                                <strong>Selected {this.props.type}s</strong>
                                {this.renderList(this.state.selected, 'selected')}
                            </div>
                        ) : (
                            ''
                        )}

                        {this.state.recent && this.state.recent.length > 0 ? (
                            <div>
                                <strong>Recent {this.props.type}s</strong>
                                {this.renderList(this.state.recent, 'recent')}
                            </div>
                        ) : (
                            ''
                        )}
                        {this.state.search && this.state.search.length > 0 ? (
                            <div>
                                <strong>All {this.props.type}s</strong>
                                {this.renderList(this.state.search, 'search')}
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </Selector>
        )
    }
}

export default DropdownSelector
